module.exports = __webpack_public_path__ + "static/media/seed3.79f0f036.svg";